import { supabase } from "./supabase";

export function cartReducer(state, action) {
  switch (action.type) {
    case "LOAD": return action.items;
    case "ADD": {
      const existing = state.find(i => i.id === action.product.id);
      if (existing) return state.map(i => i.id === action.product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...state, { ...action.product, qty: 1 }];
    }
    case "REMOVE": return state.filter(i => i.id !== action.id);
    case "UPDATE_QTY": return state.map(i => i.id === action.id ? { ...i, qty: action.qty } : i).filter(i => i.qty > 0);
    case "CLEAR": return [];
    case "RECONCILE": // action.products: current products array — clamps qty to stock
      return state.map(i => {
        const p = action.products.find(p => p.id === i.id);
        if (!p) return i;
        const qty = action.inventoryManagement && p.stock != null ? Math.min(i.qty, p.stock) : i.qty;
        return { ...i, stock: p.stock, product_form: p.product_form, qty };
      }).filter(i => i.qty > 0);
    default: return state;
  }
}

// Sync cart state to Supabase (debounced — called after every cart change)
export const syncCartToSupabase = async (cart, userId) => {
  if (!userId) return;
  // Remove items no longer in cart
  const productIds = cart.map(item => item.id);
  await supabase.from("cart_items").delete().eq("user_id", userId).not("product_id", "in", `(${productIds.join(",")})`);
  // Upsert current cart items
  if (cart.length > 0) {
    await supabase.from("cart_items").upsert(
      cart.map(item => ({ user_id: userId, product_id: item.id, qty: item.qty })),
      { onConflict: "user_id,product_id" }
    );
  }
};

// Load cart from Supabase, joining with products to get full product data
export const loadCartFromSupabase = async (userId) => {
  if (!userId) return [];
  const { data } = await supabase
    .from("cart_items")
    .select("qty, product_id, products(*)")
    .eq("user_id", userId);
  if (!data) return [];
  return data
    .filter(item => item.products)
    .map(item => ({
      ...item.products,
      id: item.product_id,
      qty: item.qty,
    }));
};
